// @ts-nocheck
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { GridContainerProps } from "@insite/mobius/GridContainer/GridContainer";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { formSmallGridProps } from "@store/Themes/common/props/form";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
// import { tableGetEllipsisCellProps, tableProps } from "@store/Themes/common/props/table"; // Greif
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Greif Custom Code - Start */
import Download from "@store/Library/Components/Toolkit/Icons/Download";
import { buttonStyles } from "@store/Themes/common/mixins/button";
import { tableGetEllipsisCellProps, tableProps } from "@store/Themes/common/props/table";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
/* Greif Custom Code - End */

export interface HistoryFilterProps {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    clearButton?: ButtonPresentationProps; // Greif
    exportButton?: ButtonPresentationProps; // Greif
    tagWrapper?: TagWrapperProps;
}

export const historyFilterProps: HistoryFilterProps = {
    wrapper: {},
    container: formSmallGridProps.gridContainer,
    /* Greif Custom Code - Start */
    clearButton: {
        variant: "tertiary",
    },
    /* Greif Custom Code - End */

    // Greif
    exportButton: {
        variant: "tertiary",
        icon: {
            src: Download,
            position: "left",
        },
        css: css`
            ${buttonStyles("solid")}

            ${breakpoint("xs", "down")} {
                width: 100%;
                margin-top: ${pxToRem(8)};
            }
        `,
    }, // Greif
    tagWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    ${x => spacingStyles(x.theme.design.typography.spacing.base, null)}
                `,
            },
        },
    },
};

export interface HistoryTableProps {
    loadingOverlay?: LoadingOverlayProps;
    container?: InjectableCss;
    wrapper?: InjectableCss;
    noResultsText?: TypographyProps;
    dataTable?: DataTableProps;
    headingWrapper?: FlexWrapperPresentationProps;
    checkboxHeader?: DataTableHeaderProps;
    checkboxCell?: DataTableCellProps;
    orderNumberHeader?: DataTableHeaderProps;
    orderNumberCell?: DataTableCellProps;
    dateHeader?: DataTableHeaderProps;
    dateCell?: DataTableCellProps;
    shipToHeader?: DataTableHeaderProps;
    shipToCell?: DataTableCellProps;
    customerPOHeader?: DataTableHeaderProps;
    customerPOCell?: DataTableCellProps;
    statusHeader?: DataTableHeaderProps;
    statusCell?: DataTableCellProps;
    totalHeader?: DataTableHeaderProps;
    totalCell?: DataTableCellProps;
    buttonHeader?: DataTableHeaderProps;
    buttonCell?: DataTableCellProps;
    button?: ButtonPresentationProps;
    /* Greif Custom Code - Start */

    actionHeader?: DataTableHeaderProps;
    actionCell?: DataTableCellProps;
    shippmentHeader?: DataTableCellProps;
    daysOverdueHeader?: DataTableCellProps;
    currencyHeader?: DataTableCellProps;
    settledOnHeader?: DataTableCellProps;
    shippmentCell?: DataTableCellProps;
    daysOverdueCell?: DataTableCellProps;
    currencyCell?: DataTableCellProps;
    settledOnCell?: DataTableCellProps;
    requestedDateHeader?: DataTableHeaderProps;
    requestedDateCell?: DataTableCellProps;
    /* Greif Custom Code - End */
}

export const historyTableProps: HistoryTableProps = {
    loadingOverlay: { minHeight: 150 },
    container: {
        css: css`
            ${x => spacingStyles(x.theme.design.typography.spacing.large, null)}
        `,
    },
    wrapper: tableProps.wrapper,
    noResultsText: typographyGetNoResultsAltProps({ spaced: true }),
    dataTable: tableProps.dataTable,
    headingWrapper: {
        gap: pxToRem(16),
        verticalGap: "0", // Greif
        extendedStyles: {
            wrapper: resultCountProps.wrapper,
            content: {
                css: css`
                    justify-content: space-between;
                `,
            },
        },
    },
    checkboxHeader: tableProps.selectionCell,
    checkboxCell: tableProps.selectionCell,
    orderNumberHeader: {},
    orderNumberCell: {},
    dateHeader: {},
    dateCell: {},
    shipToHeader: { tight: true },
    shipToCell: {
        /* Greif Custom Code - Start */
        ...tableGetEllipsisCellProps(290),
        css: css`
            ${tableGetEllipsisCellProps(150).css}

            ${breakpoint("xl")} {
                ${tableGetEllipsisCellProps(250).css}
            }
        `,
        /* Greif Custom Code - End */
    },
    customerPOHeader: {},
    customerPOCell: tableGetEllipsisCellProps(95),
    statusHeader: {},
    statusCell: tableGetEllipsisCellProps(95),
    totalHeader: tableProps.amountHeader,
    totalCell: tableProps.amountCell,
    buttonHeader: tableProps.tightHeader,
    buttonCell: tableProps.tightCell,
    button: tableProps.button,
    /* Greif Custom Code - Start */
    actionHeader: tableGetEllipsisCellProps(100),
    actionCell: tableGetEllipsisCellProps(100),
    shippmentHeader: {},
    shippmentCell: tableGetEllipsisCellProps(95),
    daysOverdueHeader: {},
    daysOverdueCell: {
        ...tableGetEllipsisCellProps(35),
        typographyProps: {
            css: css`
                &&& {
                    overflow: unset;
                    white-space: break-spaces;
                }
            `,
        },
    },
    currencyHeader: {},
    currencyCell: tableGetEllipsisCellProps(95),
    settledOnHeader: {},
    settledOnCell: tableGetEllipsisCellProps(95),
    requestedDateHeader: {
        css: css`
            width: ${pxToRem(150)};
        `,
        typographyProps: {
            css: css`
                &&& {
                    overflow: unset;
                    white-space: break-spaces;
                }
            `,
        },
    },
    requestedDateCell: {},
    /* Greif Custom Code - End */
};
